import classNames from 'classnames'
import { CircleAlert, CircleCheck, X } from 'lucide-react'
import React, { FC } from 'react'

import { Button } from '../button/button.js'

export type NotificationVariant = 'success' | 'error' | 'warning'

export interface NotificationData {
    id: string
    variant: NotificationVariant
    title: string
    message?: string
}

export interface NotificationProps extends NotificationData {
    onClose: () => void
    /** Translated accessible name of the close button. */
    closeLabel: string
    duration?: number
}

const VARIANT_ICON_MAP: Record<NotificationVariant, React.ReactElement> = {
    success: <CircleCheck />,
    error: <CircleAlert />,
    warning: <CircleAlert />,
}

export const Notification: FC<NotificationProps> = ({
    variant,
    title,
    message,
    onClose,
    closeLabel,
    duration,
}) => {
    const iconElement = VARIANT_ICON_MAP[variant]

    return (
        <div
            className={classNames('notification', `notification--${variant}`)}
            role="status"
            aria-live="polite"
            style={{ '--notification-duration': `${duration}ms` } as React.CSSProperties}
        >
            <div className="notification__icon">{iconElement}</div>
            <div className="notification__content">
                <div className="notification__title">{title}</div>
                {message && <div className="notification__message">{message}</div>}
            </div>

            <Button
                className="notification__close"
                aria-label={closeLabel}
                variant="tertiary"
                iconLeft={X}
                iconOnly={true}
                text=""
                onClick={onClose}
            ></Button>
            <div className="notification__timer" />
        </div>
    )
}
